import { Component, OnInit, OnDestroy, ViewChildren, QueryList, EventEmitter } from '@angular/core';
import { IxellAPIService, Roles, StatsPrefsPeriod, StatsKeyfactorInfo, StatsGraphProps, StatsGraphDataX, StatsGraphDataY, StatsGraphShape, StatsGraphDataInterval, StatsGraphData, StatsGraphFilterKind, StatsGraphPrefs } from 'src/app/tools/api.service'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ColorKind, Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';
import { StorageService } from 'src/app/tools/storage.service';
import { Observable, Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DiagramComponent } from 'src/app/chart/mg-chart.component';
import { ChartContent, ChartDataset } from '../../entities/ChartContent';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Router } from '@angular/router';
import { ActiveElement, Chart, ChartEvent, ChartOptions, defaults, DoughnutController } from 'chart.js';
import { toFont, toPercentage } from 'chart.js/helpers';
import { KeyFactorProps } from '../kf-modal/kf-modal.component';
import { topojson } from '@lacour/chartjs-chart-geo';
import europe from 'src/assets/stats/europe.json'


@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
})

export class StatisticsComponent implements OnInit, OnDestroy {
  @ViewChildren(DiagramComponent)
  charts: QueryList<DiagramComponent>;

  Form = new UntypedFormGroup({
    Table: new UntypedFormControl('', [Validators.required]),
    Options: new UntypedFormControl('')
  });

  role: Roles;
  Utils = Utils;
  StatsGraphDataX = StatsGraphDataX;
  StatsGraphDataY = StatsGraphDataY;
  StatsGraphShape = StatsGraphShape;

  availablePeriods = [
    { name: "stats.keyFactors.period.today", value: StatsPrefsPeriod.TODAY },
    { name: "stats.keyFactors.period.thisWeek", value: StatsPrefsPeriod.WEEK },
    { name: "stats.keyFactors.period.thisMonth", value: StatsPrefsPeriod.MONTH },
    { name: "stats.keyFactors.period.thisYear", value: StatsPrefsPeriod.YEAR },
    { name: "stats.keyFactors.period.sinceBegin", value: StatsPrefsPeriod.ALWAYS }
  ];
  selectedPeriod: StatsPrefsPeriod;

  graphShapes = [
    { name: "stats.graphs.shapes.table", value: StatsGraphShape.TABLE },
    { name: "stats.graphs.shapes.lines", value: StatsGraphShape.LINES },
    { name: "stats.graphs.shapes.pie", value: StatsGraphShape.PIE },
    { name: "stats.graphs.shapes.donut", value: StatsGraphShape.DONUT },
    { name: "stats.graphs.shapes.map", value: StatsGraphShape.MAP },
    { name: "stats.graphs.shapes.hist", value: StatsGraphShape.HIST },
    { name: "stats.graphs.shapes.browsing", value: StatsGraphShape.BROWSING },
    { name: "stats.graphs.shapes.actions", value: StatsGraphShape.ACTIONS }
  ];

  keyfactors: StatsKeyfactorInfo[] = null;
  areKeyfactorsLoading: boolean = false;

  showKFModal: boolean = false;
  showAGModal: boolean = false;
  showTXTModal: boolean = false;

  txtModalText: string = "";

  graphsProps: StatsGraphProps[] = null;

  displayMap: boolean[] = [];

  // Objet
  graphResizer: Subject<boolean[]> = new Subject<boolean[]>();

  saveActive: boolean = false;
  graphQuery = new EventEmitter<void>();
  graphBuffer: StatsGraphPrefs[] = [];

  // Sub
  private statsGetKeyfactorsSub: any;
  private statsGetKFPeriodSub: any;
  private statsSetKFPeriodSub: any;
  private statsGetGraphsSub: any;
  private statsGetGraphDataSub: any;
  private statsSetKFOrderSub: any;
  private statsSetGraphPrefsSub: any;
  private statsAddUsableGraphSub: any;
  private getCountriesPropertiesSub: any;
  private onLangChangeSub: any;

  private roleSub: any;

  constructor(private headerService: HeaderService, private apiService: IxellAPIService, private storage: StorageService, private translate: TranslateService, private router: Router) { }

  ngOnInit() {
    this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
    this.headerService.verifyRole();

    this.headerService.changeCanBack(true);
    this.headerService.changeTitle((window.innerWidth <= 610 && window.innerWidth < window.innerHeight) ? "common.statsShort" : "common.stats");
    this.headerService.changeLogo("");

    if (!Utils.isAdminLacour(this.role) && !Utils.isAdminRenault(this.role))
      this.router.navigate(["home"]);

    this.statsGetKFPeriodSub = this.apiService.statsGetKFPeriod().subscribe(data => {
      this.selectedPeriod = data;
      this.loadKeyFactors(false);

      if (this.statsGetKFPeriodSub != null) this.statsGetKFPeriodSub.unsubscribe();
    });

    this.onLangChangeSub = this.translate.onLangChange.subscribe(() => {
      this.loadKeyFactors(false);
    });
  }

  ngAfterViewInit() {
    this.statsGetGraphsSub = this.apiService.statsGetGraphs().subscribe(data => {
      this.graphsProps = data;
      this.displayMap = (new Array(data.length)).fill(true);

      this.loadGraphs();

      if (this.statsGetGraphsSub != null) this.statsGetGraphsSub.unsubscribe();
    });
  }

  ngOnDestroy() {
    if (this.statsGetKeyfactorsSub != null) this.statsGetKeyfactorsSub.unsubscribe();
    if (this.statsGetKFPeriodSub != null) this.statsGetKFPeriodSub.unsubscribe();
    if (this.statsSetKFPeriodSub != null) this.statsSetKFPeriodSub.unsubscribe();
    if (this.statsGetGraphsSub != null) this.statsGetGraphsSub.unsubscribe();
    if (this.statsGetGraphDataSub != null) this.statsGetGraphDataSub.unsubscribe();
    if (this.statsSetKFOrderSub != null) this.statsSetKFOrderSub.unsubscribe();
    if (this.statsSetGraphPrefsSub != null) this.statsSetGraphPrefsSub.unsubscribe();
    if (this.statsAddUsableGraphSub != null) this.statsAddUsableGraphSub.unsubscribe();
    if (this.getCountriesPropertiesSub != null) this.getCountriesPropertiesSub.unsubscribe();
    if (this.onLangChangeSub != null) this.onLangChangeSub.unsubscribe();

    if (this.roleSub != null) this.roleSub.unsubscribe();
  }

  loadKeyFactors(save: boolean) {
    if (this.selectedPeriod == null)
      return;

    if (save) {
      this.statsSetKFPeriodSub = this.apiService.statsSetKFPeriod(this.selectedPeriod).subscribe(() => {
        if (this.statsSetKFPeriodSub != null) this.statsSetKFPeriodSub.unsubscribe();
      });
    }

    let language = this.storage.get("actualLanguage");
    if (language == "" || language == null)
      language = "fr";

    this.areKeyfactorsLoading = true;
    this.keyfactors = [];

    this.statsGetKeyfactorsSub = this.apiService.statsGetKeyfactors(this.selectedPeriod, language).subscribe(data => {
      this.keyfactors = data;
      this.areKeyfactorsLoading = false;

      if (this.statsGetKeyfactorsSub != null) this.statsGetKeyfactorsSub.unsubscribe();
    },
    error => {
      this.areKeyfactorsLoading = false;
    });
  }

  loadGraphs() {
    this.sendEnlargeTable();
  }

  getShapeName(shape: StatsGraphShape): string {
    return this.graphShapes.find(graphShape => graphShape.value == shape).name;
  }

  getEnlargeTable(): boolean[] {
    let array: boolean[] = [];

    for (let graphProps of this.graphsProps)
      array.push(graphProps.graph.isEnlarged);

    return array;
  }

  sendEnlargeTable() {
    this.graphResizer.next(this.getEnlargeTable());
  }

  movedGraph(moved: { sourceIdx: number, targetIdx: number }) {
    this.moveItemInArray(this.graphsProps, moved.sourceIdx, moved.targetIdx);

    for (let i = 0; i < this.graphsProps.length; i++)
      this.graphsProps[i].graph.prio = i;

    this.sendEnlargeTable();

    this.saveActive = true;
  }

  resizedGraph(changed: { idx: number, enlarged: boolean }) {
    this.graphsProps[changed.idx].graph.isEnlarged = changed.enlarged;

    this.sendEnlargeTable();

    this.saveActive = true;
  }

  closedGraph(idx: any) {
    this.graphsProps.splice(idx, 1);

    this.sendEnlargeTable();

    this.saveActive = true;
  }

  editGraph() {
    this.saveActive = true;
  }

  saveGraphsPrefs() {
    if (!this.saveActive)
      return;

    this.saveActive = false;

    this.graphBuffer = [];
    this.graphQuery.emit();

    while (this.graphBuffer.length < this.graphsProps.length) { }

    this.statsSetGraphPrefsSub = this.apiService.statsSetGraphPrefs(this.graphBuffer).subscribe(() => {
      if (this.statsSetGraphPrefsSub != null) this.statsSetGraphPrefsSub.unsubscribe();
    })
  }

  async addGraph(event: number) {
    if (this.saveActive) {
      this.saveActive = false;

      this.graphBuffer = [];
      this.graphQuery.emit();

      while (this.graphBuffer.length < this.graphsProps.length) { }

      await this.apiService.statsSetGraphPrefs(this.graphBuffer).toPromise().then(() => { }).catch(() => { });
    }

    this.statsAddUsableGraphSub = this.apiService.statsAddUsableGraph(event).subscribe(() => {
      this.ngAfterViewInit();

      if (this.statsAddUsableGraphSub != null) this.statsAddUsableGraphSub.unsubscribe();
    })

    this.toggleAGModal();
  }

  receiveFilters(event: StatsGraphPrefs) {
    this.graphBuffer.push(event);
  }

  timestampToString(timestamp: number | string, hasHours: boolean, language: string, range: boolean = false) {
    let timeAsNumber = (typeof timestamp == 'number') ? timestamp : Number(timestamp);

    let timeAsDate = new Date(timeAsNumber * 1000);

    let date: string = timeAsDate.toLocaleDateString(language);
    if (hasHours) {
      date += " " + timeAsDate.toLocaleTimeString(language, { hour: '2-digit', minute: '2-digit' });
      if (range)
        date += " -> " + (new Date((timeAsNumber + 3600) * 1000)).toLocaleTimeString(language, { hour: '2-digit', minute: '2-digit' })
    }

    return date;
  }

  graphSubmit(dataX: StatsGraphDataX, dataY: StatsGraphDataY, filters: any, idx: number) {
    if ('isTrusted' in filters)
      return;

    let language = this.storage.get("actualLanguage");
    if (language == "" || language == null)
      language = "fr";

    let chart: DiagramComponent = this.charts.find(chart => chart.uid == idx)
    chart.content = null;
    chart.loading = true;

    this.statsGetGraphDataSub = this.apiService.statsGetGraphData(dataX, dataY, language, filters).subscribe(async data => {
      if (data.error != undefined && data.error != null && data.error.length > 0) {
        chart.loading = false;
        alert(this.translate.instant(data.error));
        return;
      }


      let timestamps: number[] = [];

      if (data.interval == StatsGraphDataInterval.None) {
        for (let key in data.data) {
          for (let label in data.data[key]) {
            for (let timestamp in data.data[key][label].records) {
              timestamps.push(Number(timestamp));
            }
          }
        }
      }
      else {
        let since: number = data.start;
        let until: number = data.end;
        let isHour = (data.interval == StatsGraphDataInterval.Hour);
        let noSince = (since == null);
        let noUntil = (until == null);
        if (isHour || noSince || noUntil) {
          let first = Number.MAX_VALUE;
          let last = Number.MIN_VALUE;

          for (let key in data.data) {
            for (let label in data.data[key]) {
              for (let timestamp in data.data[key][label].records) {
                let realTimestamp = Number(timestamp)
                if (realTimestamp < first)
                  first = realTimestamp;
                if (realTimestamp > last)
                  last = realTimestamp;
              }
            }
          }

          if (isHour || noSince)
            since = first;
          if (isHour || noUntil)
            until = last;
        }

        for (let time = since; time <= until;) {
          timestamps.push(time);

          switch (data.interval) {
            case StatsGraphDataInterval.Hour:
            {
              time += 3600;
              break;
            }
            case StatsGraphDataInterval.Day:
            {
              time += 86400;
              break;
            }
            case StatsGraphDataInterval.Week:
            {
              time += 604800;
              time -= ((time - 345600) % 604800);
              break;
            }
            case StatsGraphDataInterval.Month:
            {
              let tmp = new Date(time * 1000);
              time = Math.floor(Date.UTC(tmp.getUTCFullYear(), tmp.getUTCMonth() + 1, 1) / 1000);
              break;
            }
            case StatsGraphDataInterval.Year:
            {
              let tmp = new Date(time * 1000);
              time = Math.floor(Date.UTC(tmp.getUTCFullYear() + 1, 1, 1) / 1000);
              break;
            }
          }
        }
      }

      timestamps = [...new Set(timestamps)].sort((a, b) => a < b ? -1 : (a > b ? 1 : 0));

      let days: string[] = [];
      for (let timestamp of timestamps) {
        days.push(this.timestampToString(timestamp, data.interval <= StatsGraphDataInterval.Hour, language));
      }

      let tableLabels: string[] = null;
      if (data.interval <= StatsGraphDataInterval.Hour) {
        tableLabels = [];
        for (let timestamp of timestamps)
          tableLabels.push(this.timestampToString(timestamp, data.interval <= StatsGraphDataInterval.Hour, language, true));
      }

      let actions: { date: string, user: string, label: string }[] = [];

      let datasets: ChartDataset<any>[] = [];
      for (let key in data.data) {
        for (let label in data.data[key]) {
          let recs = data.data[key][label];

          for (let action of (recs.actions || []))
            actions.push({ date: action.time, user: label, label: action.label });

          if (!recs.records)
            continue;

          let dataset: ChartDataset<any> = { label: '', key: '', data: [] };
          let datac: number[] = new Array(days.length).fill(0);

          for (let timestamp in recs.records) {
            let date: string = this.timestampToString(timestamp, data.interval <= StatsGraphDataInterval.Hour, language);

            let iidx: number = days.indexOf(date);

            datac[iidx] = recs.records[timestamp];
          }

          dataset.label = label;
          dataset.key = key ?? "";
          dataset.data = datac;

          datasets.push(dataset);
        }
      }

      let shapeOverride: StatsGraphShape|null = null;
      try {
        let nations = topojson.feature(europe as any, europe.objects.collection as TopoJSON.GeometryCollection<TopoJSON.Properties>).features;
        let alpha3codes: string[] = [...new Set(nations.map((d) => d.properties.ADM0_A3_GB))];
        let pays = await this.apiService.getCountriesProperties(alpha3codes).toPromise();
        let countriesLabels = pays.map(p => p.codeLexique);
        let datasetsLabels = datasets.map(d => d.label);

        let found = countriesLabels.filter(o => datasetsLabels.some((n) => o === n)).length > 0;
        if (!found && this.graphsProps[idx].graph.latestShape == StatsGraphShape.MAP) {
          shapeOverride = this.graphsProps[idx].graph.availableShapes[0];
        }

        this.displayMap[idx] = found;
      }
      catch (e) { }
      
      chart.content = new ChartContent({
        data: {
          labels: days,
          tableLabels: tableLabels,
          datasets: datasets
        },
        colorKind: ColorKind.Classic,
        keyName: data.keyName,
        labelName: data.labelName,
        xName: data.xName,
        yName: data.yName,
        actions: actions,
        arbTbl: data.arbitraryTable?.logs,
        arbNames: data.arbitraryTable?.names,
        arbSort: data.arbitraryTable?.canSort,
        shapeOverride: shapeOverride,
        specific: [
          {
            type: 'line',
            options: {
              responsive: true,
              scales: {
                y: {
                  min: 0
                }
              },
              plugins: {
                legend: {
                  display: false
                }
              }
            }
          },
          {
            type: 'bar',
            options: {
              responsive: true,
              scales: {
                y: {
                  min: 0
                }
              },
              plugins: {
                legend: {
                  display: false
                }
              }
            },
          },
          {
            type: 'pie',
            options: {
              responsive: true,
              plugins: {
                legend: {
                  display: false
                },
                datalabels: {
                  textAlign: "center",
                  formatter: (value, ctx) => {
                    if (value == 0)
                      return "";

                    let fullSum = 0;

                    let dataArr = ctx.dataset.data;
                    dataArr.map(data => {
                      fullSum += data as number;
                    });

                    let prevSum = ctx.dataset.data.slice(0, ctx.dataIndex).reduce((prev, curr) => (prev as number) + (curr as number), 0) as number;
                    let pAngle = (prevSum * (2 * Math.PI) / fullSum);
                    let mAngle = ((prevSum + (value/2)) * (2 * Math.PI) / fullSum);
                    let aAngle = ((prevSum + value) * (2 * Math.PI) / fullSum);

                    let side = Math.min(ctx.chart.chartArea.bottom - ctx.chart.chartArea.top, ctx.chart.chartArea.right - ctx.chart.chartArea.left);
                    let r = side / 2;
                    let hR = side / 4;

                    let fPercentage = (value * 100 / fullSum);

                    let centerTxt = { x: hR * Math.sin(mAngle), y: hR * Math.cos(mAngle) };

                    let txt = fPercentage.toFixed(2) + "%";

                    let canv2d = ctx.chart.canvas.getContext("2d");
                    canv2d.font = toFont(ctx.chart.options.font).string;

                    let title = (ctx.chart.config.data.labels[ctx.dataIndex] as string);
                    let full = [title.replace(/ \(.*\)/, "").replace(/ \[.*\]/, ""), value.toString(), txt];
                    let fullMetrics = full.map(t => canv2d.measureText(t));

                    let fS = ((ctx.chart.options.font == null) ? defaults.font.size : ctx.chart.options.font.size);

                    let ogLen = full.length;
                    for (let i = 0; i < ogLen; i++) {
                      let metrics = fullMetrics.reduce((prev, curr) => (prev && prev.width > curr.width) ? prev : curr);

                      let width = metrics.width;
                      let height = ((fS + 2) * full.length) - 2;

                      let hW = (width) / 2;
                      let hH = height / 2;

                      let result = Utils.isPolygonInPieSlice(
                        [
                          { x: centerTxt.x - hW, y: centerTxt.y - hH },
                          { x: centerTxt.x + hW, y: centerTxt.y - hH },
                          { x: centerTxt.x + hW, y: centerTxt.y + hH },
                          { x: centerTxt.x - hW, y: centerTxt.y + hH }
                        ],
                        { radius: r, startAngle: pAngle, lenAngle: aAngle }
                      );

                      if (result)
                        return full;

                      full.shift();
                      fullMetrics.shift();
                    }

                    return "";
                  },
                  color: (context) => {
                    let currColor: string = context.dataset.backgroundColor[context.dataIndex];

                    let r: number = parseInt(currColor.substr(1, 2), 16);
                    let g: number = parseInt(currColor.substr(3, 2), 16);
                    let b: number = parseInt(currColor.substr(5, 2), 16);

                    let y: number = (((0.2126 * r) + (0.7152 * g) + (0.0722 * b)) >= 128) ? 0 : 255;

                    return Utils.rgb2hex(y, y, y);
                  }
                }
              }
            },
            plugins: [ChartDataLabels]
          },
          {
            type: 'doughnut',
            options: {
              responsive: true,
              plugins: {
                legend: {
                  display: false
                },
                datalabels: {
                  textAlign: "center",
                  formatter: (value, ctx) => {
                    if (value == 0)
                      return "";

                    let fullSum = 0;

                    let dataArr = ctx.dataset.data;
                    dataArr.map(data => {
                      fullSum += data as number;
                    });

                    const maxSize = Math.max((Math.min(ctx.chart.chartArea.width, ctx.chart.chartArea.height) - (DoughnutController.defaults.spacing as number)) / 2, 0);
                    let cutout = Math.min(toPercentage(DoughnutController.defaults.cutout as string | number, maxSize), 1);

                    let prevSum = ctx.dataset.data.slice(0, ctx.dataIndex).reduce((prev, curr) => (prev as number) + (curr as number), 0) as number;
                    let pAngle = (prevSum * (2 * Math.PI) / fullSum);
                    let mAngle = ((prevSum + (value/2)) * (2 * Math.PI) / fullSum);
                    let aAngle = ((prevSum + value) * (2 * Math.PI) / fullSum);

                    let side = Math.min(ctx.chart.chartArea.bottom - ctx.chart.chartArea.top, ctx.chart.chartArea.right - ctx.chart.chartArea.left);
                    let r = side / 2;
                    let cutR = r * cutout;
                    let midR = r * ((cutout + 1) / 2);

                    let fPercentage = (value * 100 / fullSum);

                    let centerTxt = { x: midR * Math.sin(mAngle), y: midR * Math.cos(mAngle) };

                    let txt = fPercentage.toFixed(2) + "%";

                    let canv2d = ctx.chart.canvas.getContext("2d");
                    canv2d.font = toFont(ctx.chart.options.font).string;

                    let title = (ctx.chart.config.data.labels[ctx.dataIndex] as string);
                    let full = [title.replace(/ \(.*\)/, "").replace(/ \[.*\]/, ""), value.toString(), txt];

                    let fullMetrics = full.map(t => canv2d.measureText(t));

                    let fS = ((ctx.chart.options.font == null) ? defaults.font.size : ctx.chart.options.font.size);

                    let ogLen = full.length;
                    for (let i = 0; i < ogLen; i++) {
                      let metrics = fullMetrics.reduce((prev, curr) => (prev && prev.width > curr.width) ? prev : curr);

                      let width = metrics.width;
                      let height = ((fS + 2) * full.length) - 2;

                      let hW = (width) / 2;
                      let hH = height / 2;

                      let rect = [
                        { x: centerTxt.x - hW, y: centerTxt.y - hH },
                        { x: centerTxt.x + hW, y: centerTxt.y - hH },
                        { x: centerTxt.x + hW, y: centerTxt.y + hH },
                        { x: centerTxt.x - hW, y: centerTxt.y + hH }
                      ];
                      let result1 = Utils.isPolygonInPieSlice(
                        rect,
                        { radius: r, startAngle: pAngle, lenAngle: aAngle }
                      );
                      let result2 = Utils.doesPolygonCollideWithPieSlice(
                        rect,
                        { radius: cutR, startAngle: pAngle, lenAngle: aAngle }
                      );

                      if (result1 && !result2)
                        return full;

                      full.shift();
                      fullMetrics.shift();
                    }

                    return "";
                  },
                  color: (context) => {
                    let currColor: string = context.dataset.backgroundColor[context.dataIndex];

                    let r: number = parseInt(currColor.substr(1, 2), 16);
                    let g: number = parseInt(currColor.substr(3, 2), 16);
                    let b: number = parseInt(currColor.substr(5, 2), 16);

                    let y: number = (((0.2126 * r) + (0.7152 * g) + (0.0722 * b)) >= 128) ? 0 : 255;

                    return Utils.rgb2hex(y, y, y);
                  }
                }
              }
            },
            plugins: [ChartDataLabels]
          },
          {
            type: 'choropleth',
            options: {
              responsive: true,
              scales: {
                projection: {
                  axis: 'x',
                  projection: 'conicEquidistant',
                  projectionScale: 1.4,
                  projectionOffset: [-200, 200],
                },
                color: {
                  axis: 'x',
                  display: false,
                },
              },
              plugins: {
                legend: {
                  display: false
                }
              }
            } as ChartOptions<'choropleth'>
          },
          {
            type: 'tree',
            options: {
              responsive: true,
              showNames: true,
              minWidth: 2,
              maxWidth: 15,
              borderColor: "rgba(0, 0, 0, 0.1)",
              rdata: data,
              plugins: {
                legend: {
                  display: false
                }
              },
              onClick: (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
                for (let element of elements) {
                  let details: string = (chart.data.datasets[element.datasetIndex].data[element.index] as any).details;
                  if (details !== undefined && details !== null && details.length > 0) {
                    this.txtModalText = details;
                    this.toggleTXTModal();
                  }
                }
              }
            } as ChartOptions<'tree'>
          }
        ]
      });

      if (this.statsGetGraphDataSub != null) this.statsGetGraphDataSub.unsubscribe();
    },
    error => {
      chart.loading = false;
      alert(this.translate.instant("stats.graphs.errors.default"));
    });
  }

  updatePanelDescription(text: string, idx: number) {
    document.getElementById('panel-desc-' + idx).innerHTML = text;
  }


  moveItemInArray<T>(array: T[], sourceIdx: number, targetIdx: number) {
    if (sourceIdx == targetIdx)
      return;

    while (sourceIdx < targetIdx) {
      let tmp: T = array[sourceIdx];
      array[sourceIdx] = array[sourceIdx + 1]
      array[sourceIdx + 1] = tmp;
      sourceIdx++;
    }

    while (sourceIdx > targetIdx) {
      let tmp: T = array[sourceIdx];
      array[sourceIdx] = array[sourceIdx - 1]
      array[sourceIdx - 1] = tmp;
      sourceIdx--;
    }
  }

  toggleKFSettings() {
    this.showKFModal = !this.showKFModal;
  }

  toggleAGModal() {
    this.showAGModal = !this.showAGModal;
  }

  toggleTXTModal() {
    this.showTXTModal = !this.showTXTModal;
  }

  saveKFSettings(event: KeyFactorProps[]) {
    this.statsSetKFOrderSub = this.apiService.statsSetKFOrder(event.filter(e => e.visible).map(e => e.name)).subscribe(() => {
      this.toggleKFSettings();
      this.loadKeyFactors(false);

      if (this.statsSetKFOrderSub != null) this.statsSetKFOrderSub.unsubscribe();
    },
    error => {
      this.toggleKFSettings();
      if (this.statsSetKFOrderSub != null) this.statsSetKFOrderSub.unsubscribe();
    });
  }
}
